import { render, staticRenderFns } from "./PaginacionComponent.vue?vue&type=template&id=fd69949e&"
import script from "./PaginacionComponent.vue?vue&type=script&lang=js&"
export * from "./PaginacionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports